// extracted by mini-css-extract-plugin
export var editButton = "_jp-0";